import { render, staticRenderFns } from "./DevLogin.vue?vue&type=template&id=5ff54b95&scoped=true&"
import script from "./DevLogin.vue?vue&type=script&lang=js&"
export * from "./DevLogin.vue?vue&type=script&lang=js&"
import style0 from "./DevLogin.vue?vue&type=style&index=0&id=5ff54b95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff54b95",
  null
  
)

export default component.exports